module.exports = __webpack_public_path__ + "static/media/10.0e40ba19.jpg";